import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import animate from "animate.css";
import schema from "async-validator";
import dialog from "./utils/dialog";
import $scroll from "@utils/loading";
import cookie from "@utils/store/cookie";
import SlideVerify from 'vue-monoplasty-slide-verify';//滑块

import "@assets/iconfont/iconfont";
import "@assets/iconfont/iconfont.css";
import "@assets/js/media_750";
import "vue-ydui/dist/ydui.base.css";
import "@assets/css/base.css";
import "@assets/css/reset.css";
import "@assets/css/style.css";
import { isWeixin, parseQuery, getUrlparam } from "@utils";
import vueLazyLoad from "vue-lazyload";
import { loginOrderInformation } from "@api/movie";
Vue.use(vueLazyLoad, {
  preload: 1.3, //加载高度比。
  loading: require("@assets/images/noPictrue.png"), //加载时的过渡图片
  error: require("@assets/images/err.png"), //加载失败的图片
  attempt: 1 //每次加载的张数。
});
Vue.use(animate);
Vue.use(SlideVerify);
Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== "production";
Vue.prototype.$validator = function(rule) {
  return new schema(rule);
};
Vue.prototype.$scroll = $scroll;
Vue.prototype.$dialog = dialog;

const CACHE_KEY = "clear_0.0.1";

if (!cookie.has(CACHE_KEY)) {
  cookie.clearAll();
  cookie.set(CACHE_KEY, 1);
}
// let insToken=localStorage.getItem("LOGIN")
// insertToken({token:insToken}).then(res=>{
// })

let cookieName = "VCONSOLE";
let query = parseQuery();
let urlSpread = query["spread"];
let vconsole = query[cookieName.toLowerCase()];
let md5Crmeb = "b14d1e9baeced9bb7525ab19ee35f2d2"; //CRMEB MD5 加密开启vconsole模式
let md5UnCrmeb = "3dca2162c4e101b7656793a1af20295c"; //UN_CREMB MD5 加密关闭vconsole模式

if (urlSpread !== undefined) {
  var spread = cookie.get("spread");
  urlSpread = parseInt(urlSpread);
  if (!Number.isNaN(urlSpread) && spread !== urlSpread) {
    cookie.set("spread", urlSpread || 0);
  } else if (spread === 0 || typeof spread !== "number") {
    cookie.set("spread", urlSpread || 0);
  }
}

const _isWechat = isWeixin();
const _isparams = getUrlparam()

if (vconsole !== undefined) {
  if (vconsole === md5UnCrmeb && cookie.has(cookieName))
    cookie.remove(cookieName);
} else vconsole = cookie.get(cookieName);

if (vconsole !== undefined && vconsole === md5Crmeb) {
  cookie.set(cookieName, md5Crmeb, 3600);
  const module = () => import("vconsole");
  module().then(Module => {
    new Module.default();
  });
}
if (_isparams &&_isparams.sign) {
  // console.log(_isparams,"_isparams");
     // 解密 获取电影票信息
     loginOrderInformation(_isparams).then((res)=>{
      //  console.log(res.data.token,"main.js-res.data.token.expires_time")
       const expires_time = new Date(res.data.token.expires_time.replace(/-/g, "/")).getTime();
      const datas = {
      token: res.data.token.token,
      expires_time: expires_time
      };
      
      store.commit("LOGIN", datas);
      // 电影信息
    }).catch((r)=>{
      // dialog.error(r.msg);
      console.log(r,"错误");
    })
}

const startL = router.history._startLocation;
if (_isWechat && startL.indexOf("/festival") === -1 && _isWechat && startL.indexOf("/scanCode") === -1) {
  const module = () => import("@libs/wechat");
  module().then(Module => {
    // console.log('走了2遍2222222222222222222222222222222')
    Module.default().then(() => Module.oAuth());
  });
}

const $vm = new Vue({
  router,
  store,
  render: h => h(App)
});

setTimeout(() => {
  $vm.$mount("#app");
}, 300);
